/* Premium touches: magnetic buttons. Skips touch devices, reduced motion and the theme editor. (Inertia scrolling was removed because it interfered with page scrolling.) */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var fine=matchMedia('(hover:hover) and (pointer:fine)').matches;
  var editor=!!(window.Shopify&&window.Shopify.designMode);
  if(reduce||editor||!fine)return;

  var SEL='.neon-hero__actions a,.neon-pk__cta,.neon-ct__submit,.neon-cs__submit,.neon-proof__cta';
  var R=70,PULL=.28,els=[];
  function collect(){els=[].slice.call(document.querySelectorAll(SEL))}
  collect();
  document.addEventListener('shopify:section:load',collect);
  var raf2=null,mx=0,my=0;
  function tick(){
    raf2=null;
    els.forEach(function(el){
      var r=el.getBoundingClientRect();
      var cx=r.left+r.width/2,cy=r.top+r.height/2;
      var dx=mx-cx,dy=my-cy;
      var halfW=r.width/2+R,halfH=r.height/2+R;
      if(Math.abs(dx)<halfW&&Math.abs(dy)<halfH){
        el.style.translate=(dx*PULL).toFixed(1)+'px '+(dy*PULL).toFixed(1)+'px';
      }else if(el.style.translate){
        el.style.translate='';
      }
    });
  }
  addEventListener('pointermove',function(e){mx=e.clientX;my=e.clientY;if(!raf2)raf2=requestAnimationFrame(tick)},{passive:true});
  document.addEventListener('pointerleave',function(){els.forEach(function(el){el.style.translate=''})});
})();
